import { yleTunnusSdkUrl } from 'services/properties/frontend';
import Script from 'next/script';
import { useEffect } from 'react';
import { initializeTunnus } from 'services/yleTunnusSdk';
import { useUILanguage } from 'hooks/useUILanguage';
import { CustomSearch } from 'components/Search';
import logger from 'services/logger';
import { useCustomSearch } from 'components/Search/useCustomSearch';
import { useTunnusContext } from 'contexts/TunnusContext';
import { useAnalyticsAvailability } from 'contexts/AnalyticsAvailabilityContext';
import { useAreenaService } from 'contexts/AreenaServiceContext';

function useRefreshOnLoginStateChange(): void {
  const { isAuthenticated, yleTunnusInstance } = useTunnusContext();

  useEffect(() => {
    if (yleTunnusInstance) {
      const subscriber = yleTunnusInstance.state.subscribe((state) => {
        if (state.loggedIn !== isAuthenticated) {
          window.location.reload();
        }
      });
      return () => {
        subscriber.unsubscribe();
      };
    }
  }, [isAuthenticated, yleTunnusInstance]);
}

export const YleTunnus = (): JSX.Element => {
  const language = useUILanguage();
  const { areenaService } = useAreenaService();

  const { setYleTunnusInstance } = useTunnusContext();
  const searchConfig = useCustomSearch(areenaService);
  const { isAvailable: isAnalyticsAvailable, hasErrored: hasAnalyticsErrored } =
    useAnalyticsAvailability();
  useRefreshOnLoginStateChange();

  return (
    <>
      {(isAnalyticsAvailable || hasAnalyticsErrored) && (
        <Script
          src={yleTunnusSdkUrl}
          onLoad={() => {
            initializeTunnus(language, searchConfig)
              .then((yleTunnusInstance) => {
                setYleTunnusInstance(yleTunnusInstance);
              })
              .catch((e) => {
                logger.error(e, 'Error during YleTunnus initialization');
              });
          }}
        />
      )}
      <CustomSearch searchConfig={searchConfig} />
    </>
  );
};
